import React from 'react';
import { Card, CardContent, Typography, Avatar, Box, Rating } from '@mui/material';

function TestimonialCard({ testimonial }) {
    const { customer_name, customer_image, content, rating, position } = testimonial;

    return (
        <Card sx={{ height: '100%', p: 2 }}>
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Avatar
                        src={customer_image || 'https://via.placeholder.com/50/1976d2/ffffff?text=User'}
                        alt={customer_name}
                        sx={{ width: 56, height: 56, mr: 2 }}
                    />
                    <Box>
                        <Typography variant="h6">{customer_name}</Typography>
                        <Typography variant="body2" color="text.secondary">
                            {position || 'Customer'}
                        </Typography>
                    </Box>
                </Box>
                <Rating value={rating} readOnly sx={{ mb: 2 }} />
                <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
                    "{content}"
                </Typography>
            </CardContent>
        </Card>
    );
}

export default TestimonialCard;